import React, { FC, useCallback } from 'react';

import ActionRow from './ActionRow';
import { ActionType, RouteToGroupAction as RouteToGroupActionType } from 'src/actions/rules/actions';
import { StyledDropdown, StyledTypeDescription } from 'src/presentation/components/pages/rules/shared/StyledComponents';
import useRoutingGroups from 'src/presentation/components/pages/rules/hooks/useRoutingGroups';

type RouteToGroupActionProps = {
  action: RouteToGroupActionType;
  onDelete: Function;
  onUpdate: Function;
};

const RouteToGroupAction: FC<RouteToGroupActionProps> = ({ action, onDelete, onUpdate }) => {
  const { loadingState, values: routingGroupOptions } = useRoutingGroups();

  const onChangeGroup = useCallback(
    groupId => {
      action.updateGroup(groupId);
      onUpdate(ActionType.RouteToGroup, action);
    },
    [action, onUpdate]
  );

  if (loadingState === 'loading') return null;
  return (
    <ActionRow type={ActionType.RouteToGroup} onDelete={onDelete}>
      <StyledTypeDescription>Assign to Inbox</StyledTypeDescription>
      <StyledDropdown
        data-aid="assignInbox-selectButton"
        maxRows={5}
        onSelect={onChangeGroup}
        options={routingGroupOptions}
        placeholder="Select inbox"
        searchable
        value={action.routingGroupId}
      />
    </ActionRow>
  );
};

export default RouteToGroupAction;
